<template>
  <NuxtLayout
    name="radar"
    :bread-crumb-list="breadcrumb"
  >
    <template #main>
      <div class="main">
        <SectionTitle
          :title="`${countryName}の雨雲レーダー`"
          :left-text="`日本時刻 ${now.locale(ja).format('M/D(ddd) H時')}`"
          share-category="RADAR_COUNTRY"
          :share-title="title"
          is-h1
        />
        <MapRadar
          :now="now"
          :lat="countryIdList[countryId]?.lat ?? 35"
          :lon="countryIdList[countryId]?.lon ?? 135"
          zoom="3"
        />
      </div>
    </template>
    <template #main-bottom>
      <div class="main">
        <text-link
          :text="`${countryName}の天気を見る`"
          :href="countryId"
        />
        <CommonCountryList
          is-country
          is-radar
        />
      </div>
    </template>
  </NuxtLayout>
</template>

<script setup>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import ja from 'dayjs/locale/ja'
import countryIdList from '~/data/table/country_id_list.json'

dayjs.extend(utc)
dayjs.extend(timezone)

const route = useRoute()
const areaId = route.params.area
const country = route.params.country
const countryId = `/${areaId}/${country}/`
if (!(countryId in countryIdList)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid'
  })
}

const now = dayjs().startOf('hour').tz('Asia/Tokyo')

const runtimeConfig = useRuntimeConfig()
const domain = runtimeConfig.public.hostDomain

const countryName = countryIdList[countryId].country_ja

const breadcrumb = [
  {
    text: '世界天気',
    link: `${domain}/onebox/tenki/world/`
  },
  {
    text: '雨雲レーダー 世界',
    link: `${domain}/onebox/tenki/world/radar/`
  },
  {
    text: `${areaLabelMap[areaId]}`,
    link: `${domain}/onebox/tenki/world/radar/${areaId}/`
  },
  {
    text: countryName
  }
]
const title = `${countryName}の雨雲レーダー - ウェザーニュース`
useCommonHead({
  title,
  description: `【48時間予想の${countryName}雨雲レーダー】リアルタイムな雨雲の動きから最大48時間先の予報まで確認できます。旅の出発前に現地の2週間天気も併せてチェック。天気・気象に関する全てのサポートは【予報精度No.1ウェザーニュース】にお任せください。`,
  keywords: `${countryName},雨雲レーダー,48時間`,
  appTitle: countryName,
  appCountKey: route.path.toLowerCase(),
  iconUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_wradar_white@2x.png`,
  iconGrayUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_wradar_trans@2x.png`,
  iconSettingUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_wradar@2x.png`
})
useCommonJsonld({ breadcrumb })
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
</style>
